export const writeToClipboard = async (data, { onError, onSuccess }) => {
    try {
        await window.navigator.clipboard.writeText(data);
    }
    catch (error) {
        // Rule disabled, as throwing on a failed copying to clipboard is a bit too much
        if (onError) {
            onError(error);
        }
        return;
    }
    if (onSuccess) {
        onSuccess();
    }
};
